import Vue from "vue"
import utilsApi from "../../api/utils"
const initialObject = {
  business: {
    name: undefined,
    short_name: undefined,
    description: undefined,
    email: undefined,
    media: undefined,
    logo: undefined,
    address: undefined
  },
  currencies: {},
  locales: [],
  default_locale: {},
  _id: undefined,
  name: undefined,
  domain: undefined,
  status: undefined,
  alert: { body: undefined, status: undefined },
  config: undefined,
  mail_config: undefined,
  head: undefined,
  manifest: undefined,
  createdAt: undefined,
  updatedAt: undefined
}
const ignoreObjectsFields = ["createdAt", "updatedAt"]

// general state for the site

const initialState = {
  sites: [],
  count: 0,
  page: 1,
  fetched: false,
  error: false,
  object: initialObject,
  isNew: false,
  selected: []
}

const state = Object.assign({}, initialState)

const getters = {
  sites: (state) => state.sites,
  sitesIndex: (state) => (payload) => {
    const { param, parent, key } = payload || {}
    const result = payload
      ? param
        ? key
          ? parent
            ? state[param] && state[param][parent] && state[param][parent][key]
              ? state[param][parent][key]
              : undefined
            : state[param] && state[param][key]
            ? state[param][key]
            : undefined
          : state[param]
          ? state[param]
          : undefined
        : state
      : state
    //console.table(result)
    return result
  },
  sitesError: (state) => state.error,
  sites_Object: (state) => state.object,
  sites_isNew: (state) => state.isNew,
  sites_selected: (state) => state.selected,
  sites_dataShape: (state) => state.dataShape
}
const actions = {
  async DELETE_sites({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.deleteObject("sites", object)
    if (apiResponse != null) {
      //console.log("DELETE_COLLECTIONS", apiResponse, object)
      dispatch("FETCH_PAGE_sites", state.page)
      return true
    } else {
      commit("SITES_ERROR")
      return false
    }
  },
  async DELETE_SELECTED_sites({ state, dispatch, commit }) {
    let deletions = await state.selected.map(async (object) => {
      return await dispatch("DELETE_sites", object)
    })
    if (deletions.includes(false)) {
      return false
    } else {
      commit("SET_sites", {
        param: "selected",
        value: []
      })
      return true
    }
  },
  UPDATE_sitesState({ commit }, payload) {
    commit("SET_sites", payload)
    return true
  },
  async UPDATE_sites({ commit, dispatch, state }, object) {
    const filtered = Object.keys(object)
      .filter((key) => !ignoreObjectsFields.includes(key))
      .reduce((obj, key) => {
        obj[key] = object[key]
        return obj
      }, {})
    let apiResponse = await utilsApi.updateObject("sites", filtered)
    if (apiResponse != null) {
      //console.log("EN UPDATE COLLECTIONS", apiResponse, object)
      commit("SITES_SETTING", apiResponse)

      dispatch("FETCH_PAGE_sites", state.page)
      return true
    } else {
      commit("SITES_ERROR")
      return false
    }
  },
  async CREATE_sites({ commit, dispatch, state }, object) {
    let apiResponse = await utilsApi.createObject("sites", object)
    if (apiResponse != null) {
      commit("SET_sites", apiResponse.site)

      dispatch("FETCH_PAGE_sites", state.page)
      return true
    } else {
      commit("SITES_ERROR")
      return false
    }
  },
  async FETCH_sites({ commit }) {
    let apiResponse = await utilsApi.getObjects("sites")
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      //console.log("FETCH COLLECTION API RESPONSE", apiResponse.site)
      commit("SITES_SETTING", apiResponse)
      return true
    } else {
      commit("SITES_ERROR")
      return false
    }
  },

  async FETCH_PAGE_sites({ commit }, page) {
    let apiResponse = await utilsApi.getObjectsPage("sites", page)
    //console.log("apiResponse", apiResponse)
    if (apiResponse != null) {
      commit("SITES_SETTING", { ...apiResponse, page })
      return true
    } else {
      commit("SITES_ERROR")
      return false
    }
  },

  UPDATE_OBJECT_sites({ commit }, payload) {
    commit("SET_OBJECT_SITE", payload)
    return true
  },
  CLEAN_OBJECT_sites({ commit }) {
    commit("SET_OBJECT_SITE_INITIAL")
    return true
  },
  async CLEAN_STORE_sites({ commit }) {
    const initialStateKeys = Object.keys(initialState)

    await Promise.all(
      initialStateKeys.map(async (current) => {
        await commit("SET_sites", {
          param: current,
          value: initialState[current]
        })
        return true
      })
    )

    return true
  },
  UPDATE_SELECTED_sites({ commit }, payload) {
    commit("SET_SELECTED_SITES", payload)
    return true
  },
  async seedSite(locale_id) {
    return await utilsApi.seedSite(locale_id)
  }
}
const mutations = {
  SITES_SETTING: (state, { sites, count = false }) => {
    //console.log(state)
    state.count = count || state.sites?.length || 0
    state.sites = sites
    state.fetched = true
    state.error = false
  },
  SITES_ERROR: (state) => {
    state.sites = null
    state.fetched = true
    state.dataShape = []
    state.error = false
  },
  SET_OBJECT_SITE: (state, payload) => {
    Object.keys(initialObject).map((key) => {
      state.object[key] = payload[key]
    })
  },
  SET_OBJECT_SITE_INITIAL: (state) => {
    state.object = { ...initialObject }
  },
  SET_SELECTED_SITES: (state, selectedSite) => {
    state.selected = selectedSite
  },
  SET_sites: (state, payload) => {
    const { param, parent, key, value } = payload
    //console.log("SETTING FORMS STATE IN", param, value, key, parent)
    key
      ? parent
        ? state[param]
          ? state[param][parent]
            ? Vue.set(state[param][parent], key, value)
            : Vue.set(state[param], parent, {}) &&
              Vue.set(state[param][parent], key, value)
          : Vue.set(state, param, {}) &&
            Vue.set(state[param], parent, {}) &&
            Vue.set(state[param][parent], key, value)
        : state[param]
        ? Vue.set(state[param], key, value)
        : Vue.set(state, param, {}) && Vue.set(state[param], key, value)
      : Vue.set(state, param, value)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
